import { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { FolderOpen, Download, Loader2 } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const CATEGORIA_LABEL: Record<string, string> = {
  informe: 'Informe',
  contrato: 'Contrato',
  certificado: 'Certificado',
  factura: 'Factura',
  otro: 'Otro',
};

export default function PortalDocumentos() {
  const [docs, setDocs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await (supabase as any)
        .from('portal_documentos')
        .select('*')
        .order('created_at', { ascending: false });
      setDocs((data ?? []) as any[]);
      setLoading(false);
    })();
  }, []);

  async function descargar(path: string) {
    const { data, error } = await supabase.storage
      .from('portal-documentos')
      .createSignedUrl(path, 60);
    if (error || !data) return toast.error('No se pudo descargar');
    window.open(data.signedUrl, '_blank');
  }

  if (loading) return <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin" /></div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold">Documentos</h1>
        <p className="text-muted-foreground">Documentos compartidos por tu proveedor</p>
      </div>

      {docs.length === 0 && (
        <Card><CardContent className="py-12 text-center text-muted-foreground">No hay documentos compartidos.</CardContent></Card>
      )}

      <div className="grid gap-2">
        {docs.map(d => (
          <Card key={d.id}>
            <CardContent className="py-4 flex items-center gap-3">
              <FolderOpen className="h-8 w-8 text-primary flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-medium truncate">{d.titulo}</p>
                  <Badge variant="outline" className="text-xs">{CATEGORIA_LABEL[d.categoria] || d.categoria}</Badge>
                </div>
                {d.descripcion && <p className="text-sm text-muted-foreground line-clamp-1">{d.descripcion}</p>}
                <p className="text-xs text-muted-foreground">
                  {d.created_at && format(new Date(d.created_at), "d 'de' MMM yyyy", { locale: es })}
                </p>
              </div>
              <Button size="sm" variant="outline" onClick={() => descargar(d.file_path)}>
                <Download className="h-4 w-4" />
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
